/* ============================================================
   Collection Tab Nav — Active pill auto-scroll into view
   - Mobile only (skipped on PC where track has no overflow)
   - Minimum movement: only scrolls if active pill is out of view
   - Uses track.scrollLeft directly (avoids scrollIntoView vertical jump)
   ============================================================ */
(function () {
  'use strict';

  function scrollActiveIntoView() {
    var track = document.querySelector('.jc-tab-nav__track');
    if (!track) return;

    if (track.scrollWidth <= track.clientWidth) return;

    var active = track.querySelector('.jc-tab-nav__pill--active');
    if (!active) return;

    var trackRect = track.getBoundingClientRect();
    var activeRect = active.getBoundingClientRect();
    var pad = 24;

    var rightOverflow = activeRect.right - (trackRect.right - pad);
    var leftOverflow = (trackRect.left + pad) - activeRect.left;

    if (rightOverflow > 0) {
      track.scrollLeft += rightOverflow;
    } else if (leftOverflow > 0) {
      track.scrollLeft -= leftOverflow;
    }
  }

  function run() {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(scrollActiveIntoView);
    } else {
      scrollActiveIntoView();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (document.fonts && typeof document.fonts.ready === 'object') {
    document.fonts.ready.then(run);
  }
})();
